import { UseTableCellProps } from 'react-table';
import { MoneyOrPercentField } from './money-or-percent-field';

export function EditableColumn<T extends Record<string, string>>({
    row: { index, original },
    column: { id, rules, percent, section },
}: UseTableCellProps<T>) {
    return (
        <MoneyOrPercentField
            index={index}
            original={original}
            id={id}
            rules={rules}
            percent={percent}
            section={section}
        />
    );
}
